import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import {
  getSourceName,
  NodeFunctionsSource,
  ServerPresetSummary,
} from 'dashboard/models/graph-backend';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { Label } from 'design-system/components/Text/Text';

interface SourceFunctionMappingFixedProps {
  source: NodeFunctionsSource;
  nodeFunctionToken: string;
  presetSummary: ServerPresetSummary;
  sourceIdx: number;
}

const LabelWrapper = styled.div`
  border-bottom: 1px solid ${Color.BorderHairline};
`;

const ParamMappingsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${Spacing[4]};
  row-gap: ${Spacing[1]};
`;

const SourceFunctionMappingFixed = ({
  source,
  nodeFunctionToken,
  presetSummary,
}: SourceFunctionMappingFixedProps) => {
  const functionMappingIdx = source['function-mappings'].findIndex(
    (fm) => fm.token === nodeFunctionToken,
  );

  const headerText = `Source: ${getSourceName(source)}`;
  return (
    <>
      <LabelWrapper>
        <Label size='lg' weight='bold'>
          {headerText}
        </Label>
      </LabelWrapper>
      <Spacer height={2} />
      <ParamMappingsContainer>
        {source['function-mappings']?.[functionMappingIdx]?.['param-mappings']?.map(
          (paramMapping) => {
            const paramFieldSchema = presetSummary['param-schema'].find(
              (fs) => fs.key === paramMapping.destination,
            );
            return (
              paramFieldSchema && (
                <div key={paramMapping.destination}>
                  <Label size='md'>{paramFieldSchema.label || paramMapping.destination}</Label>
                  <Input value={paramMapping.path} disabled />
                  <Spacer height={2} />
                </div>
              )
            );
          },
        )}
      </ParamMappingsContainer>
    </>
  );
};

export default SourceFunctionMappingFixed;
